module.exports = __webpack_public_path__ + "static/losaltos-7725c1b73ecb8ff92907f99edab309c3.jpg";